import { apiClient } from "@/services/apiClient";

/** The zones shipping is priced in (spec 8c2aab49 D4). */
export type DeliveryZoneId = "montevideo" | "interior";

/**
 * What the platform charges to deliver the physical document an RFQ produces.
 *
 * A LIST now, keyed by zone. It used to be a single value, defended on the
 * grounds that "a two-discipline RFQ is one package and pays one delivery
 * fee". That is still true — one package, one fee — but the fee now depends on
 * WHERE the package goes, and the destination is a property of the request,
 * not of the leg. So there is still exactly one rate per shipment; it is
 * selected by zone rather than being the only row.
 */
export interface QuoteDeliveryRate {
  zone: DeliveryZoneId;
  /** Centésimos UYU, IVA-inclusive, added once to the consumer's total. */
  deliveryFeeMinor: number;
  deliveryFeeIncludesIva: boolean;
  updatedAt: string;
}

export function getQuoteDeliveryRates(): Promise<QuoteDeliveryRate[]> {
  return apiClient
    .get<QuoteDeliveryRate[]>("/platform/quote-delivery-rate")
    .then((res) => res.data);
}

export function updateQuoteDeliveryRate(payload: {
  zone: DeliveryZoneId;
  deliveryFeeMinor: number;
}): Promise<QuoteDeliveryRate> {
  return apiClient
    .put<QuoteDeliveryRate>(`/platform/quote-delivery-rate/${payload.zone}`, {
      deliveryFeeMinor: payload.deliveryFeeMinor,
    })
    .then((res) => res.data);
}
